module.exports = __webpack_public_path__ + "static/media/maxi-toys.e103a200.svg";